import React from 'react';
import { List, Datagrid, TextField, NumberField, ReferenceField } from 'react-admin';

import useDefaultFilter from '@/utils/useDefaultFilter';
import { Can, ACCESS, useAuth } from '@/utils/auth';
import { USER, TRANSACTION, MACHINE } from '@/vars';
import { MRO_REPORT_PRODUCTS } from '@/vars/resources';
import routes from '@/vars/routes';
import { Page } from '@/components';
import TransactionFilter from '../TransactionFilter';

const MROTransactionByProductList = ({ staticContext, ...props }) => {
  const { permissions } = useAuth();
  const isAdmin = permissions.role === USER.ROLE.ADMIN;

  var filter = {
    ...useDefaultFilter('client'),
    mode: MACHINE.MODE.MRO,
  };
  if (!isAdmin) { filter.status = TRANSACTION.STATUS.SUCCESS }

  const listProps = {
    ...props,
    basePath: routes.mroTransactionsByProduct,
    resource: MRO_REPORT_PRODUCTS,
    hasCreate: false,
    hasEdit: false,
    hasShow: false,
    hasList: true,

    filter,
    sort: { field: 'date', order: 'DESC' },
    bulkActionButtons: false,
    perPage: 25,
    filters: <TransactionFilter searchKeys={null} />,
  };

  return (
    <Can module={ACCESS.MRO_REPORT}>
      <Page sectionTitle="MRO Report" title="List by product">
        <List {...listProps}>
          <Datagrid>
            <TextField label="Product name" source="product.name" />
            {isAdmin && (
              <ReferenceField label="Company" source="client" reference="clients" link={false}>
                <TextField source="companyName" />
              </ReferenceField>
            )}
            <TextField label="Total QTY Sold" source="totalQty" />
            <NumberField label="Total Revenue (Credit)" source="totalCredit" />
          </Datagrid>
        </List>
      </Page>
    </Can>
  );
};

export default MROTransactionByProductList;
